import { createContext, useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';

import { useAppStore } from 'hooks/redux';

export const CREDIT_SCORE_DRAWER_PATH = '/planning-tools/credit-score';

type CreditScoreDrawerContextValue = {
  openCreditScoreDrawer: (options?: { setup?: boolean }) => void;
  closeCreditScoreDrawer: () => void;
};

export const CreditScoreDrawerContext = createContext<CreditScoreDrawerContextValue | null>(null);

export const useOpenCreditScore = (): {
  isDrawerEnabled: boolean;
  openCreditScore: () => void;
  openCreditScoreSetup: () => void;
} => {
  const drawer = useContext(CreditScoreDrawerContext);
  const navigate = useNavigate();
  const store = useAppStore();

  const navigateToCreditScore = useCallback(() => {
    const moveNonReportsFf = featureFlagsSelectors.getFeatureFlag(store.getState(), 'reportsMoveRfndtrkrCrdtscr');
    navigate(`/${moveNonReportsFf ? 'planning-tools' : 'reports'}/credit-score`);
  }, [navigate, store]);

  const openCreditScore = useCallback(
    () => (drawer ? drawer.openCreditScoreDrawer() : navigateToCreditScore()),
    [drawer, navigateToCreditScore],
  );
  const openCreditScoreSetup = useCallback(
    () => (drawer ? drawer.openCreditScoreDrawer({ setup: true }) : navigateToCreditScore()),
    [drawer, navigateToCreditScore],
  );

  return { isDrawerEnabled: Boolean(drawer), openCreditScore, openCreditScoreSetup };
};
